import IconButton from "@material-ui/core/IconButton";
import FlightIcon from "@material-ui/icons/Flight";
import PaymentIcon from '@material-ui/icons/Payment';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { DiasCalendarioStyle } from "./styles";
import { useHistory } from "react-router-dom";
import { FormatoFechaIso } from "./../../../utils/FormatFecha"

const DiaCalendario = (props) => {
  const history = useHistory()
  const { row, MesActual } = props;
  const classes = DiasCalendarioStyle();
  const eventosMes = useSelector((store) => store.calendario.eventosMes);
  const handlerClickDate = (fecha) => {
    history.push(`Calendario/${format(new Date(fecha), "MMddyyyy")}`, {
      fechaCorta: format(new Date(fecha), "dd/MM/yyyy")
    })
  }
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    body: {
      fontSize: 8,
    },
  }))(TableCell)
  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.white,
      },
    },
  }))(TableRow)
  const StyledBadge = withStyles((theme) => ({
    badge: {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  }))(Badge)
  const validardiaMes = (fecha) => {
    return format(new Date(fecha), "MM") === MesActual ? true : false;
  }
  return (
    <StyledTableRow>
      {row.dias.map((dia, index) => (
        <StyledTableCell key={dia.FechaCorta}>
          <span
            className={
              (validardiaMes(dia.FechaCorta))
                ? classes.dias
                : classes.diasNoMes
            }
          >
            {dia.NumeroDia}
          </span>
          <br />
          <div
            onClick={() => handlerClickDate(dia.FechaCorta)}
          >
            {
              eventosMes.map((rowEvento, ie) => {
                if (FormatoFechaIso({ date: rowEvento.Fecha, formato: "MMddyyyy" }) === FormatoFechaIso({ date: dia.Fecha, formato: "MMddyyyy" }) && validardiaMes(dia.FechaCorta)) {
                  return (
                    <div key={rowEvento.Fecha}>
                      <IconButton
                        aria-label="plane"
                      >
                        <StyledBadge
                          badgeContent={rowEvento.CanAereos}
                          color="error"
                          fontSize="small"
                        >
                          <FlightIcon fontSize="small" />
                        </StyledBadge>
                      </IconButton>
                      <IconButton
                        aria-label="plane"
                      >
                        <StyledBadge
                          badgeContent={rowEvento.CanLiquidaciones}
                          color="primary"
                          fontSize="small"
                        >
                          <PaymentIcon fontSize="small" />
                        </StyledBadge>
                      </IconButton>
                      <IconButton
                        aria-label="plane"
                      >
                        <StyledBadge
                          badgeContent={rowEvento.CantidadViajes}
                          color="secondary"
                          fontSize="small"
                        >
                          <AirportShuttleIcon fontSize="small" />
                        </StyledBadge>
                      </IconButton>
                    </div>
                  )
                }
                return null
              })
            }
          </div>
        </StyledTableCell>
      ))}
    </StyledTableRow>
  );
};
export default DiaCalendario;
